import * as React from 'react';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { FullDiscountExtraInfo } from '@/shop/c_shop/component';
// import TrackUtils from '../../utils/TrackUtils';
import './index.css';

interface IProps {
  // source: number,
  // shopId: string,
  // multiSkuModel: MultiSkuModel,
  // goodDetailData: GoodDetailData,
  // couponTips?: CouponTips,
  // originPrice: GoodDetailMinPrice;
  // discountPrice: GoodDetailMinPrice;
  fullDiscountExtraInfo: FullDiscountExtraInfo;
  onClickBottomToastShow: Function;
  // onClickToShopPreview?: VoidFunction;

}

class DiscountTips extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    // if (this.props.couponTips?.shopLink) {
    //     TrackUtils.multiSkuModalEnterShopMV(this.props.multiSkuModel, this.props.goodDetailData,
    //         this.props.shopId, this.props.couponTips?.canUserCoupon, this.props.source,
    //         this.props.originPrice?.displayAmount, this.props.discountPrice?.displayAmount);
    // }
  }

  onClickToShopPreview = () => {
    // if (this.props.couponTips?.shopLink) {
    //     TrackUtils.multiSkuModalEnterShopMC(this.props.multiSkuModel, this.props.goodDetailData,
    //         this.props.shopId, this.props.couponTips?.canUserCoupon, this.props.source,
    //         this.props.originPrice?.displayAmount, this.props.discountPrice?.displayAmount);
    // }
    // WMRouter.navigateTo(this.props.couponTips?.shopLink, {}, () => {
    //     this.props.onClickToShopPreview?.();
    // });

  }

  render() {
    // @ts-ignore
    const { fullDiscountExtraInfo, onClickBottomToastShow } = this.props;
    return (
      <view className="discount-tips-wrapper">
        <view
          className="coupon-tips-container" onClick={() => {
            //空实现，防止点击事件透传至上层
          }}
        >
          <view className="coupon-tips-container-inner">
            <image className="icon" src={fullDiscountExtraInfo?.fullDiscountTipsIconFront} />
            <text className="coupon-tips-text" content={fullDiscountExtraInfo?.fullDiscountTips} />
            {
              fullDiscountExtraInfo?.fullDiscountTipsIconLast
                ? (
                  <view className="icon-wrapper" onClick={() => { onClickBottomToastShow(); }}>
                    <image className="icon" src={fullDiscountExtraInfo?.fullDiscountTipsIconLast} />
                  </view>
                ) : null
            }
          </view>

        </view>
      </view>
    );
  }
}

export default withTranslation('', {
  withRef: true,
})(DiscountTips);
